import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import { FormattedNumber as BaseFormattedNumber } from 'react-intl';

import AverageRating from 'AppComponents/AverageRating';
import UserImage from 'AppComponents/UserImage';

import Cell from './Cell';

import './styles.scss';


const FormattedNumber = (props) => {
  if (!props.value) return null;
  return (
    <BaseFormattedNumber {...props}>
      { formatted => <span styleName='number'>{ formatted }</span> }
    </BaseFormattedNumber>
  );
};

FormattedNumber.propTypes = {
  value: PropTypes.number.isRequired,
};


const User = ({ user, onClick }) => (
  <tr onClick={onClick} styleName='user'>

    <Cell styleName='image' sortParam='public_name'>
      <UserImage user={user} styleName='profile-photo' />
    </Cell>

    <Cell className='name' sortParam='public_name'>
      <Link to={`/user/${user.username}/`}>{ user.public_name }</Link>
    </Cell>

    <Cell className='chargers-visited' sortParam='num_chargers_visited'>
      <FormattedNumber value={user.num_chargers_visited} />
    </Cell>

    <Cell className='charger-reviews' sortParam='num_charger_reviews'>
      <FormattedNumber value={user.num_charger_reviews} />
    </Cell>

    <Cell className='charger-average' sortParam='charger_average_rating'>
      { user.charger_average_rating ?
        <AverageRating rating={user.charger_average_rating} styleName='average-rating' />
      : null }
    </Cell>

    <Cell className='place-reviews' sortParam='num_place_reviews'>
      <FormattedNumber value={user.num_place_reviews} />
    </Cell>

    <Cell className='place-average' sortParam='place_average_rating'>
      { user.place_average_rating ?
        <AverageRating rating={user.place_average_rating} styleName='average-rating' />
      : null }
    </Cell>

    <Cell className='place-average-walkability' sortParam='place_average_walkability_rating'>
      { user.place_average_walkability_rating ?
        <AverageRating
          rating={user.place_average_walkability_rating}
          type='walk'
          styleName='average-rating'
        />
      : null }
    </Cell>

  </tr>
);

User.propTypes = {
  user: PropTypes.shape({
    username: PropTypes.string,
    public_name: PropTypes.string,
    num_charger_reviews: PropTypes.number,
    num_place_reviews: PropTypes.number,
    num_chargers_visited: PropTypes.number,
    charger_average_rating: PropTypes.number,
    place_average_rating: PropTypes.number,
    place_average_walkability_rating: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default User;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/UserRankings/User/index.jsx